module.exports = __webpack_public_path__ + "static/media/Argus Filch 3.20cb1169.jpg";